// extracted by mini-css-extract-plugin
module.exports = {"deepBlue":"#001529","white":"#ffffff","blue":"#409eff"};